var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('Menu'),_c('Filters'),_c('router-view',[_c('MapScreen')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }